<script setup lang="ts">
import { computed } from 'vue';
import type { FieldSchema } from '../../../types';
import { convertToTitleCase } from '@Helpers';
import { API_URL } from '@Constants';

const props = withDefaults(
  defineProps<{
    error?: string;
    field?: FieldSchema;
    placeholder?: string;
    required?: boolean;
  }>(),
  {
    placeholder: 'components.forms.placeholder.common',
  }
);

const model = defineModel<string[]>();

const options = computed(() => {
  // prettier-ignore
  return props.field?.values?.length ? props.field?.values
    : props.field?.edit?.options.length ? props.field?.edit?.options
    : [];
});

const selectedOptions = computed(() => {
  if (!model.value) return [];

  return model.value?.map((modelOption: any) =>
    options.value.find((option: any) => option._id === modelOption._id)
  );
});

function openWaiver(waiverId: string) {
  const link = `/file/print-intake-waiver/${waiverId}`;

  return `${API_URL}${link}`;
}
</script>

<template>
  <div>
    <AFieldMultiSelect
      v-model="model"
      optionLabel="title"
      :error
      :options
      :placeholder="field?.settings.placeholder || placeholder"
      :required="field?.settings.required || required"
    />

    <div
      v-if="selectedOptions && selectedOptions.length > 0"
      class="mt-1 flex flex-col gap-2"
    >
      <div
        v-for="(option, index) in selectedOptions"
        class="flex w-full max-w-full items-center justify-between gap-2 text-xs font-semibold"
        :key="index"
      >
        <p
          class="overflow-hidden text-ellipsis whitespace-nowrap rounded-md bg-gray-200 px-2 py-1 text-gray-700"
        >
          {{ convertToTitleCase(option?.title || '') }}
        </p>

        <a
          target="_blank"
          :href="openWaiver(option?._id)"
        >
          <i
            class="pi pi-print cursor-pointer rounded-md p-2 text-sm text-gray-600 transition-colors hover:bg-gray-100 active:bg-gray-200"
          ></i>
        </a>
      </div>
    </div>
  </div>
</template>
